export const LMT_ENHCMT_flushAPICallsDataReducer = {
  LMT_ENHCMT_flushAPICallsData: (state, action) => {
    state.s3FileUploadAPICall = {
      uploadFileResponses: [null, null, null, null],
      response: {},
      isLoading: false,
      isError: false,
      isSuccess: false,
    };
    state.bsVerifyTxnAPICall = {
      response: {},
      isLoading: false,
      isError: false,
      isSuccess: false,
    };
    state.saveBsDocUploadAPICall = {
      response: {},
      isLoading: false,
      isError: false,
      isSuccess: false,
    };
  },
};
